import ceo from '../images/team/ceo.jpg'
import rezo from '../images/team/rezo.jpg'
import sasha from '../images/team/sasha.jpg'
import lomidze from '../images/team/lomidze.jpg'
import bacho from '../images/team/bacho.jpg'
import kirila from '../images/team/kirila.jpg'
import anastasia from '../images/team/anastasia-portrait.jpg'
import ana from '../images/team/ana.jpg'
import dato from '../images/dato.jpg'

/**
 * The real MLMind team, one place for every page that shows people.
 * Photos are of the actual team, never stock.
 *
 * nameKey / roleKey are translation keys. `delivery: true` marks the people
 * a client works with day to day on a project (shown on /process).
 */
const team = [
  { id: 'giorgi', src: ceo, nameKey: 'name1', roleKey: 'name2' },
  { id: 'revaz', src: rezo, nameKey: 'contact15', roleKey: 'name6', delivery: true },
  { id: 'aleksandr', src: sasha, nameKey: 'name5', roleKey: 'name6', delivery: true },
  { id: 'lomidze', src: lomidze, nameKey: 'name3', roleKey: 'name4', delivery: true },
  { id: 'bacho', src: bacho, nameKey: 'name7', roleKey: 'name8' },
  { id: 'kirill', src: kirila, nameKey: 'name9', roleKey: 'name10', delivery: true },
  { id: 'anastasia', src: anastasia, nameKey: 'name11', roleKey: 'name12', delivery: true },
  { id: 'ana', src: ana, nameKey: 'contact14', roleKey: 'name10', delivery: true },
  { id: 'davit', src: dato, nameKey: 'name13', roleKey: 'name14' },
]

// Resolves names and roles against the active language. Locale strings carry
// stray trailing spaces, so they are trimmed here once.
export const resolveTeam = (translations, { deliveryOnly = false } = {}) =>
  team
    .filter((member) => (deliveryOnly ? member.delivery : true))
    .map((member) => ({
      ...member,
      name: (translations[member.nameKey] || '').trim(),
      role: (translations[member.roleKey] || '').trim(),
    }))

export default team
